import * as React from "react";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

import Paper from "@mui/material/Paper";
import { TablePagination } from "@mui/material";
import EquipRows from "./EquipRows";

export default function EquipTable(props) {
  const [page, setPage] = React.useState(0);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <TableContainer component={Paper}>
        <Table size="small" aria-label="a dense table">
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Type</TableCell>
              {props.arry.length > 0 &&
                props.arry[0].hasOwnProperty("Space") && (
                  <TableCell>Space</TableCell>
                )}
            </TableRow>
          </TableHead>
          <EquipRows
            arry={props.arry}
            page={page}
            handleClick={props.handleClick}
            tableName={props.tableName}
          />
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10]}
        component="div"
        count={props.arry.length}
        rowsPerPage={10}
        page={page}
        onPageChange={handleChangePage}
      />
    </Box>
  );
}
